<template>
  <div class="is-main-title">
    <h2 class="title is-4 ">Convemos</h2>
    <h2 class="subtitle is-4 is-main-subtitle">Base de Dados</h2>
    <div class="columns">
      <div class="column is-full-bar is-2">
        <h1 class="subtitle is-5"><b>PESQUISA</b></h1>
      </div>
      <div class="column is-full-bar">
        <div class="field addPadding">
          <span class="subtitle is-5">Simples </span>
          <input id="switchExample" type="checkbox" name="switchExample" class="switch" :checked="isAdvanced"
                 @click="toggleAdvancedSearch()">
          <label for="switchExample"><span class="subtitle is-5">Avançada</span></label>
        </div>
      </div>
    </div>
    <div class="columns is-simple-search is-vcentered" v-if="!isAdvanced">
      <div class="column is-2">
        <h1 class="subtitle is-6"><b>Pesquisa Simples</b></h1>
      </div>
      <div class="column is-6">
        <div class="control has-icons-right">
          <input v-model="simpleSearch" class="input is-small" type="text" placeholder="">
          <span class="icon is-small is-right">
            <i class="fas fa-search"></i>
          </span>
        </div>
      </div>
      <div class="column">
        <p class="control" @click="submitSimpleSearch">
          <a class="button is-submit">
            Pesquisar
          </a>
        </p>
      </div>
    </div>
    <div v-else>
      <h1 class="subtitle is-6 is-advanced-search"><b>Pesquisa Avançada</b></h1>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Ordem</b></p>
        </div>
        <div class="column is-6 is-not-padded">
          <div class="control">
            <div class="select is-small is-fullwidth">
              <select v-model="order" @change="setMonasteries">
                <option :value="''" :key="''"></option>
                <option v-for="order in orders" :value="order" :key="order.id">
                  {{order.order}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Convento</b></p>
        </div>
        <div class="column is-6 is-not-padded">
          <div class="control">
            <div class="select is-small is-fullwidth">
              <select v-model="monastery">
                <option :value="''" :key="''"></option>
                <option v-for="(monastery, index) in orderMonasteries" :value="monastery" :key="index">
                  {{getMonasteryName(monastery)}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Localização</b></p>
        </div>
        <div class="column is-6 is-not-padded">
          <div class="control">
            <div class="select is-small is-fullwidth">
              <select v-model="location">
                <option :value="''" :key="''"></option>
                <option v-for="location in completeLocations" :value="location" :key="location.id">
                  {{location.fullName}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Género</b></p>
        </div>
        <div class="column is-6 is-not-padded">
          <div class="control">
            <div class="select is-small is-fullwidth">
              <select v-model="gender">
                <option :value="''" :key="''"></option>
                <option v-for="gender in genders" :value="gender" :key="gender">
                  {{gender}}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Fundação</b></p>
        </div>
        <div class="column is-1 is-not-padded">
          <p>Entre</p>
        </div>
        <div class="column is-2 is-not-padded">
          <div class="control">
            <input v-model="foundation[0]" class="input is-small" type="number" placeholder="Ano">
          </div>
        </div>
        <div class="column is-1 is-not-padded">
          <p>e</p>
        </div>
        <div class="column is-2 is-not-padded">
          <div class="control">
            <input v-model="foundation[1]" class="input is-small" type="number" placeholder="Ano">
          </div>
        </div>
      </div>
      <div class="columns is-advanced-search-element is-vcentered">
        <div class="column is-2 is-not-padded">
          <p class=" is-3"><b>Extinção</b></p>
        </div>
        <div class="column is-1 is-not-padded">
          <p>Entre</p>
        </div>
        <div class="column is-2 is-not-padded">
          <div class="control">
            <input v-model="extinction[0]" class="input is-small" type="number" placeholder="Ano">
          </div>
        </div>
        <div class="column is-1 is-not-padded">
          <p>e</p>
        </div>
        <div class="column is-2 is-not-padded">
          <div class="control">
            <input v-model="extinction[1]" class="input is-small" type="number" placeholder="Ano">
          </div>
        </div>
      </div>
      <p class="control">
        <a class="button is-submit" @click="submitAdvancedSearch">
          Pesquisar
        </a>
      </p>
    </div>
    <message-overlay :information-type="overlayType" :overlay-message="overlayMessage" v-if="saved"
                     @closed="saved = false"/>
    <waiting-overlay v-if="toWait"/>
  </div>
</template>

<script>
import MessageOverlay from "../components/generic/MessageOverlay";
import WaitingOverlay from "../components/generic/WaitingOverlay";
export default {
  name: 'SearchForm',
  components: {WaitingOverlay, MessageOverlay},
  data: ()=>({
    orders: [],
    order: '',
    monasteries: [],
    orderMonasteries: [],
    monastery: {},
    locations: [],
    completeLocations: [],
    location: {},
    genders: ['Masculino', 'Feminino'],
    gender: '',
    simpleSearch: '',
    foundation: ['',''],
    extinction: ['',''],
    //Control
    toWait: false,
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9kaGxhYi5wdCIsImF1ZCI6Imh0dHA6XC9cL2RobGFiLnB0IiwiaWF0IjoxNjAwMjM2MDk0LCJuYmYiOnsiZGF0ZSI6IjIwMjEtMDItMTYgMDE6MDE6MzQuMDc4ODg1IiwidGltZXpvbmVfdHlwZSI6MywidGltZXpvbmUiOiJBbWVyaWNhXC9DaGljYWdvIn0sImRhdGEiOnsiaWQiOjEsImZpcnN0bmFtZSI6IlBhdWxvIiwibGFzdG5hbWUiOiJBbHZlcyIsImVtYWlsIjoicGF1bG9hbHZlc0BmY3NoLnVubC5wdCJ9fQ.dvBnlodFI5NQDdvddpVdaeYlTrLxW1PeMykgmJAXgok',
    saved: false,
    overlayMessage: '',
    overlayType: 'is-info',
    isAdvanced: false,
  }),
  methods:{
    async getSearchInfo(){
      const opts = {
        method: 'POST',
        headers: {'Content-Type': 'application/json; charset=UTF-8"'},
        body: JSON.stringify({token: this.token})
      };
      const res = await fetch('/convemos/API/public/index.php/MonasteryAPI/retrieveSearchInfo', opts).
      then(res => res.json());
      if(res !== null){
        this.orders = res.values.orders;
        this.monasteries = res.values.monasteries;
        this.setMonasteries();
        this.locations = res.values.locations;
        this.generateLocations();
      }else{
        this.overlayType = 'is-danger'
        this.overlayMessage = "Erro ao carregar a informação";
      }
    },
    setMonasteries(){
      if(this.order === ''){
        this.orderMonasteries = this.unifyMonasteries();
      }else{
        let orderMonasteries = [];
        let orderMonasteriesIds = [];
        for(let i=0; i<this.monasteries.length; i++){
          if((this.monasteries[i].orderId === this.order.id) &&
              (!orderMonasteriesIds.includes(this.monasteries[i].id))){
            orderMonasteries.push(this.monasteries[i]);
            orderMonasteriesIds.push(this.monasteries[i].id);
          }
        }
        this.orderMonasteries = orderMonasteries;
      }
    },
    unifyMonasteries(){
      let monasteries = [];
      let monasteriesIds = [];
      for(let i=0; i<this.monasteries.length; i++){
        if((!monasteriesIds.includes(this.monasteries[i].id + '-' + this.monasteries[i].monasteryId))){
          monasteries.push(this.monasteries[i]);
          monasteriesIds.push(this.monasteries[i].id + '-' + this.monasteries[i].monasteryId);
        }
      }
      return monasteries;
    },
    getMonasteryName(monastery){
      let monasteryName = monastery.altName
      let name = monastery.altName + ' (' + monastery.monastery + ')';
      if(monasteryName == null){
        name = monastery.monastery;
      }

      return name;
    },
    generateLocations(){
      let locations = [];
      for (const [key, value] of Object.entries(this.locations.municipalities)) {
        if(key !== '0'){
          locations.push(value);
        }
      }
      for (const [key, value] of Object.entries(this.locations.districts)) {
        if(key !== '0'){
          locations.push(value);
        }
      }
      locations.sort(function (a, b) {
        let nameA = a.name.toUpperCase(); // ignore upper and lowercase
        let nameB = b.name.toUpperCase(); // ignore upper and lowercase
        nameA = nameA.replace('Á', 'A')
        nameB = nameB.replace('Á', 'A')
        nameA = nameA.replace('Â', 'A')
        nameB = nameB.replace('Â', 'A')
        nameA = nameA.replace('É', 'E')
        nameB = nameB.replace('É', 'E')
        nameA = nameA.replace('Í', 'I')
        nameB = nameB.replace('Í', 'I')
        nameA = nameA.replace('Ó', 'O')
        nameB = nameB.replace('Ó', 'O')
        nameA = nameA.replace('Ú', 'U')
        nameB = nameB.replace('Ú', 'U')
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })

      this.completeLocations = locations;
    },
    async submitSimpleSearch(){
      this.toWait = true;
      const opts = {
        method: 'POST',
        headers: {'Content-Type': 'application/json; charset=UTF-8"'},
        body: JSON.stringify({token: this.token, term: this.simpleSearch})
      };
      const res = await fetch('/convemos/API/public/index.php/MonasteryAPI/simpleSearch', opts).
      then(res => res.json());
      if(res.values != null){
        this.$emit('searchMade', res.values)
      }else{
        this.overlayType = 'is-danger';
        this.overlayMessage = res.message.message;
        this.saved = true;
      }
      this.toWait = false;
    },
    async submitAdvancedSearch(){
      this.toWait = true;
      let terms = {token: this.token, order: this.order.id, monastery: this.monastery.monasteryId, location: this.location.id,
        gender: this.gender, foundation: this.foundation, extinction: this.extinction};
      const opts = {
        method: 'POST',
        headers: {'Content-Type': 'application/json; charset=UTF-8"'},
        body: JSON.stringify(terms)
      };
      const res = await fetch('/convemos/API/public/index.php/MonasteryAPI/advancedSearch', opts).
      then(res => res.json());
      if(res.values != null){
        this.$emit('searchMade', res.values)
      }else{
        this.overlayType = 'is-danger';
        this.overlayMessage = res.message.message;
        this.saved = true;
      }
      this.toWait = false;
    },
    async toggleAdvancedSearch() {
      this.isAdvanced = !this.isAdvanced
      if(this.isAdvanced){
        this.toWait = true;
        await this.getSearchInfo();
        this.toWait = false;
      }
    },
  },
  async created() {

  }
}
</script>

<style scoped>
.is-submit{
  background-color: #ded5c1;
  font-weight: bold;
}

.is-main-title{
  margin: 0.55em;
}

.is-main-subtitle{
  padding-top: 20px;
}

.is-full-bar{
  background-color: #ded5c1;
}

.is-simple-search{
  margin-left: 1em;
  margin-top: 1em;
}

.is-advanced-search{
  margin-left: 1.6em;
  margin-top: 1.2em;
}

.is-not-padded{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.is-advanced-search-element{
  margin-left: 2em;
}

.is-main-content p{
  font-size: 14px;
  text-align: justify;
  margin: 1em;
  line-height: 1.4;
}

.switch[type=checkbox]:checked+label::before, .switch[type=checkbox]:checked+label:before {
  background: #a7a193;
}
</style>

